import React from 'react';
import { cn } from '../../../lib/utils';
import { Button } from '../../../components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../components/ui/table';
import { Loader2, Trash2 } from 'lucide-react';
import { BalanceChecksTableProps } from '../types';

export function BalanceChecksTable({
  isDark,
  checks,
  isLoading,
  onDelete,
  formatMoney,
}: BalanceChecksTableProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-[#C9A227]" />
      </div>
    );
  }

  const th = cn('font-semibold', isDark ? 'text-slate-400' : 'text-slate-500');
  const rowCls = cn(
    'transition-colors',
    isDark ? 'border-slate-700 hover:bg-slate-800/50' : 'border-slate-100 hover:bg-slate-50',
  );

  return (
    <Table>
      <TableHeader>
        <TableRow className={rowCls}>
          <TableHead className={th}>Дата выписки</TableHead>
          <TableHead className={th}>Остаток по выписке</TableHead>
          <TableHead className={th}>Комментарий</TableHead>
          <TableHead className={th}>Действия</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {checks.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="text-center py-12 text-slate-500">
              Остатки по выписке ещё не вводили — сверить кассу не с чем
            </TableCell>
          </TableRow>
        ) : (
          checks.map((check) => (
            <TableRow key={check.id} className={rowCls}>
              <TableCell className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>
                {check.date}
              </TableCell>
              <TableCell className={cn('font-semibold', isDark ? 'text-white' : 'text-[#111111]')}>
                {formatMoney(check.amount)}
              </TableCell>
              <TableCell className={cn('max-w-xs truncate', isDark ? 'text-slate-400' : 'text-slate-500')}>
                {check.comment || '—'}
              </TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(check.id)}
                  className={cn('h-8 w-8', isDark ? 'hover:bg-slate-700' : 'hover:bg-slate-100')}
                >
                  <Trash2 className="w-4 h-4 text-red-500" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
